import { createModuleStateSelector } from '@americanexpress/travel-selectors';
import { MR_MODULE_NAME } from '../constants/modules';

export const parseSelectedKey = (rewards) => (rewards ? rewards.get('selectedKey') : '');

export const getSelectedKeySelector = (state) => parseSelectedKey(
  createModuleStateSelector(MR_MODULE_NAME)(state)
);
